export enum KeyAlphaCode {
	Enter = 'Enter',
	Space = ' ',
	/**
	 * @deprecated Only used by older browsers
	 */
	Space_Old = 'Space'
}